import { render, staticRenderFns } from "./VFatherProAnamCAxAFF.vue?vue&type=template&id=1319702e"
import script from "./VFatherProAnamCAxAFF.vue?vue&type=script&lang=js"
export * from "./VFatherProAnamCAxAFF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports